export const buildPermissionSet = (permissions = []) => {
  return new Set(Array.isArray(permissions) ? permissions : []);
};

export const checkList = ({ values = [], mode = 'all', checker }) => {
  if (!values.length) {
    return true;
  }

  return mode === 'any' ? values.some(checker) : values.every(checker);
};

export const permissions = {
  general: {
    categories: {
      globalSettings: {
        productManagement: {
          productList: {
            view: 'General.Categories.Global.ProductManagement.Products',
            create: 'ProuctManagment.ProductList.Create',
            edit: 'ProuctManagment.ProductList.Edit',
            delete: 'ProuctManagment.ProductList.Delete',
            graph: 'ProuctManagment.ProductList.Graph',
            detail: {
              view: 'ProuctManagment.ProductList.Detail',
              insertLabel: 'ProductManagement.ProductList.Detail.InsertLabel',
              viewTechSpecifications:
                'ProductManagement.ProductList.Detail.ViewTechSpecifications',
              gallery: 'ProductManagement.ProductList.Detail.Gallery',
              createBranch: 'ProductManagement.ProductList.Detail.CreateBranch',
              uploadBranch: 'ProductManagement.ProductList.Detail.UploadBranch',

              branch: {
                view: 'ProductManagement.ProductList.Detail.BranchList',
                createPartNumber:
                  'ProductManagement.ProductList.Detail.Branch.CreatePartNumber',
                create: 'ProductManagement.ProductList.Detail.Branch.Create',
                createByCode:
                  'ProductManagement.ProductList.Detail.Branch.CreateByCode',
                upload: 'ProductManagement.ProductList.Detail.Branch.Upload',
                delete: 'ProductManagement.ProductList.Detail.Branch.Delete',
                displacement:
                  'ProductManagement.ProductList.Detail.Branch.Displacement',
                gallery: 'ProductManagement.ProductList.Detail.Branch.Gallery',
                pathfix: 'ProductManagement.ProductList.Detail.Branch.Pathfix',
              },

              codding: {
                create: 'ProductManagement.ProductList.Detail.Codding.Create',
                delete: 'ProductManagement.ProductList.Detail.Codding.Delete',
                edit: 'ProductManagement.ProductList.Detail.Codding.Edit',
                setDefault:
                  'ProductManagement.ProductList.Detail.Codding.SetDefault',

                batch: {
                  view: 'ProductManagement.ProductList.Detail.Codding.Batch.List',
                  download:
                    'ProductManagement.ProductList.Detail.Codding.Batch.Download',
                  trigger:
                    'ProductManagement.ProductList.Detail.Codding.Batch.Trigger',
                },

                serial: {
                  view: 'ProductManagement.ProductList.Detail.Codding.Serial.List',
                  download:
                    'ProductManagement.ProductList.Detail.Codding.Serial.Download',
                },

                profile: {
                  edit: 'ProductManagement.ProductList.Detail.Codding.Profile.Edit',
                },
              },
              packaging: {
                activeSerialList:
                  'ProductManagement.ProductList.Detail.Packaging.ActiveSerialList',
                create: 'ProductManagement.ProductList.Detail.Packaging.Create',
                delete: 'ProductManagement.ProductList.Detail.Packaging.Delete',
                edit: 'ProductManagement.ProductList.Detail.Packaging.Edit',
                print: 'ProductManagement.ProductList.Detail.Packaging.Print',
                printSettings:
                  'ProductManagement.ProductList.Detail.Packaging.PrintSettings',
                uploadSerialFile:
                  'ProductManagement.ProductList.Detail.Packaging.UploadSerialFile',
              },
            },
          },

          branchList: {
            view: 'General.Categories.Global.ProductManagement.Branches',
            delete: 'ProuctManagment.BranchList.Delete',
            detail: 'ProuctManagment.BranchList.Detail',
            reorder: 'ProuctManagment.BranchList.Reorder',
          },
        },

        usersManagement: {
          users: {
            view: 'General.Categories.Global.UsersManagement.Users',
            changeBaseRole: 'UsersManagement.Users.ChangeBaseRole',
            changePassword: 'UsersManagement.Users.ChangePassword',
            changeStatus: 'UsersManagement.Users.ChangeStatus',
            create: 'UsersManagement.Users.Create',
            delete: 'UsersManagement.Users.Delete',
            edit: 'UsersManagement.Users.Edit',
            permissions: 'UsersManagement.Users.Permissions',
            permissionsEdit: 'UsersManagement.Users.Permissions.Edit',
            roles: 'UsersManagement.Users.Roles',
            rolesEdit: 'UsersManagement.Users.Roles.Edit',
            setAsAgent: 'UsersManagement.Users.SetAsAgent',
          },
        },

        coddingSettings: {
          groupCode: {
            view: 'General.Categories.Global.CoddingSettings.CodeGroup',
            delete: 'CoddingSettings.GroupCode.Delete',
            create: 'CoddingSettings.GroupCode.Create',
            edit: 'CoddingSettings.GroupCode.Edit',
            download: 'CoddingSettings.GroupCode.Download',
            upload: 'CoddingSettings.GroupCode.Upload',
            values: {
              view: 'CoddingSettings.GroupCode.Values',
              create: 'CoddingSettings.GroupCode.Values.Create',
              edit: 'CoddingSettings.GroupCode.Values.Edit',
              delete: 'CoddingSettings.GroupCode.Values.Delete',
            },
          },

          mappingProfile: {
            view: 'General.Categories.Global.CoddingSettings.MappingProfile',
            create: 'CoddingSettings.MappingProfile.Create',
            edit: 'CoddingSettings.MappingProfile.Edit',
            delete: 'CoddingSettings.MappingProfile.Delete',
            detail: 'CoddingSettings.MappingProfile.Detail',
            setDefault: 'CoddingSettings.MappingProfile.SetDefault',
          },

          profileGroup: {
            view: 'General.Categories.Global.CoddingSettings.ProfileGroup',
            create: 'CoddingSettings.ProfileGroup.Create',
            edit: 'CoddingSettings.ProfileGroup.Edit',
            delete: 'CoddingSettings.ProfileGroup.Delete',
            detail: 'CoddingSettings.ProfileGroup.Detail',
          },

          carFactory: {
            view: 'General.Categories.Global.CoddingSettings.CarFactory',
            create: 'CoddingSettings.CarFactory.Create',
            edit: 'CoddingSettings.CarFactory.Edit',
            delete: 'CoddingSettings.CarFactory.Delete',

            brands: {
              view: 'CoddingSettings.CarFactory.Brands',
              create: 'CoddingSettings.CarFactory.Brands.Create',
              edit: 'CoddingSettings.CarFactory.Brands.Edit',
              delete: 'CoddingSettings.CarFactory.Brands.Delete',

              models: {
                view: 'CoddingSettings.CarFactory.Brands.Models',
                create: 'CoddingSettings.CarFactory.Brands.Models.Create',
                edit: 'CoddingSettings.CarFactory.Brands.Models.Edit',
                delete: 'CoddingSettings.CarFactory.Brands.Models.Delete',

                series: {
                  view: 'CoddingSettings.CarFactory.Brands.Models.Series',
                  create:
                    'CoddingSettings.CarFactory.Brands.Models.Series.Create',
                  edit: 'CoddingSettings.CarFactory.Brands.Models.Series.Edit',
                  delete:
                    'CoddingSettings.CarFactory.Brands.Models.Series.Delete',

                  manufacturingDate: {
                    view: 'CoddingSettings.CarFactory.Brands.Models.Series.ManufacturingDate',
                    create:
                      'CoddingSettings.CarFactory.Brands.Models.Series.ManufacturingDate.Create',
                    edit: 'CoddingSettings.CarFactory.Brands.Models.Series.ManufacturingDate.Edit',
                    delete:
                      'CoddingSettings.CarFactory.Brands.Models.Series.ManufacturingDate.Delete',
                  },
                },
              },
            },
          },
        },
      },

      warehouseManagement: {
        cardex: 'General.Categories.WarehoseManagement.Cardex',
        locationManagement: {
          view: 'General.Categories.WarehoseManagement.LocationManagement.Locations',
          locations: {
            create: 'LocationManagement.Locations.Create',
            delete: 'LocationManagement.Locations.Delete',
            detail: 'LocationManagement.Locations.Detail',
            edit: 'LocationManagement.Locations.Edit',
            areas: {
              view: 'LocationManagement.Locations.Areas',
              create: 'LocationManagement.Locations.Areas.Create',
              delete: 'LocationManagement.Locations.Areas.Delete',
              edit: 'LocationManagement.Locations.Areas.Edit',
              graph: 'LocationManagement.Locations.Areas.Graph',
              baskets: {
                view: 'LocationManagement.Locations.Areas.Baskets',
                create: 'LocationManagement.Locations.Areas.Baskets.Create',
                delete: 'LocationManagement.Locations.Areas.Baskets.Delete',
                edit: 'LocationManagement.Locations.Areas.Baskets.Edit',
                print: 'LocationManagement.Locations.Areas.Baskets.Print',
              },
            },
          },
          reports:
            'General.Categories.WarehoseManagement.LocationManagement.Reports',
          stockTake:
            'General.Categories.WarehoseManagement.LocationManagement.StockTake',
        },
      },

      warehouseOperations: {
        geoMap: 'General.Categories.WarehouseOperations.Operations.GeoMap',
        activePDAs: {
          view: 'General.Categories.WarehouseOperations.Operations.PDA',
        },

        departure: {
          view: 'General.Categories.WarehouseOperations.Operations.Departure',
          create: 'Operations.Departure.Create',
          delete: 'Operations.Departure.Delete',
          detail: 'Operations.Departure.Detail',
          edit: 'Operations.Departure.Edit',
        },

        entry: {
          view: 'General.Categories.WarehouseOperations.Operations.Entry',
          delete: 'Operations.Entry.Delete',
          detail: 'Operations.Entry.Detail',
          edit: 'Operations.Entry.Edit',
          create: 'Operations.Entry.Create',
        },

        movement: {
          view: 'General.Categories.WarehouseOperations.Operations.Movement',
          create: 'Operations.Movement.Create',
          delete: 'Operations.Movement.Delete',
          detail: 'Operations.Movement.Detail',
          edit: 'Operations.Movement.Edit',
        },

        transfer: {
          view: 'General.Categories.WarehouseOperations.Operations.Transfer',
          create: 'Operations.Transfer.Create',
          delete: 'Operations.Transfer.Delete',
          detail: 'Operations.Transfer.Detail',
          edit: 'Operations.Transfer.Edit',
        },
      },

      ymsManagement: 'General.Categories.YMS.YMSManagement',
      tmsManagement: 'General.Categories.TMS.TMSManagement',
      momManagement: 'General.Categories.MOM.MOMManagement',
      mesOperation: 'General.Categories.MES.MESOperation',
      procurementsManagement:
        'General.Categories.Procurements.ProcurementsManagement',
      salesManagement: 'General.Categories.Sales.SalesManagement',

      keySettings: {
        accessLevel: {
          baseRoles: {
            create: 'AccessLevel.BaseRoles.Create',
            edit: 'AccessLevel.BaseRoles.Edit',
            view: 'General.Categories.KeySettings.AccessLevel.BaseRoles',
          },

          permissions: {
            create: 'AccessLevel.Permissions.Create',
            delete: 'AccessLevel.Permissions.Delete',
            edit: 'AccessLevel.Permissions.Edit',
            view: 'General.Categories.KeySettings.AccessLevel.Permissions',
          },

          roles: {
            create: 'AccessLevel.Roles.Create',
            edit: 'AccessLevel.Roles.Edit',
            permissions: 'AccessLevel.Roles.Permissions',
            permissionsEdit: 'AccessLevel.Roles.Permissions.Edit',
            view: 'General.Categories.KeySettings.AccessLevel.Roles',
          },
        },

        basicSettings: {
          versionControl: {
            view: 'General.Categories.KeySettings.BasicSettings.VersionControl',
            create: 'BasicSettings.VersionControl.Create',
            delete: 'BasicSettings.VersionControl.Delete',
            edit: 'BasicSettings.VersionControl.Edit',
            versions: {
              view: 'BasicSettings.VersionControl.Versions',
              create: 'BasicSettings.VersionControl.Versions.Create',
              delete: 'BasicSettings.VersionControl.Versions.Delete',
              edit: 'BasicSettings.VersionControl.Versions.Edit',
            },
          },
        },
      },
    },
    defaultSettings: {
      view: 'General.DefaultSettings',
    },
  },
};
